module.exports = __webpack_public_path__ + "static/barbed_devil-3313357f27dbaaabacbd9b37b97928f3.jpeg";